import { PluginRegistry } from './plugin.registry';
import { sharedLibraries } from './sharedLibraries';

let defaultPluginRegistry = new PluginRegistry();
let defaultInitializationPromise: Promise<void> | undefined;

async function initializePluginRegistry(pluginRegistry: PluginRegistry): Promise<void> {
  sharedLibraries.exposeSharedLibraries();
  await Promise.all([pluginRegistry.loadPluginManifestFromDeck(), pluginRegistry.loadPluginManifestFromGate()]);
  await pluginRegistry.loadPlugins();
}

export function initializePlugins(pluginRegistry?: PluginRegistry): Promise<void> {
  if (pluginRegistry) {
    return initializePluginRegistry(pluginRegistry);
  }
  if (!defaultInitializationPromise) {
    const initializationAttempt = initializePluginRegistry(defaultPluginRegistry);
    const cachedAttempt = initializationAttempt.catch((error) => {
      if (defaultInitializationPromise === cachedAttempt) {
        defaultPluginRegistry = new PluginRegistry();
        defaultInitializationPromise = undefined;
      }
      throw error;
    });
    defaultInitializationPromise = cachedAttempt;
  }
  return defaultInitializationPromise;
}

export function resetPluginInitializationForTests(): void {
  defaultPluginRegistry = new PluginRegistry();
  defaultInitializationPromise = undefined;
}
